<template>
	<div id="navWrapper">
		<div id="nav">
			<div id="navName">
				<div class="navNameContent">
					<img src="../assets/img/home/buckle.png" />
					<h1>Emily Qualmann</h1>				
				</div>
			</div>

			<div id="navBar">
				<a 	v-for="link in normal_links" 
					v-scroll-to="{ el: link.hash, offset: -75 }"
					:class="{active: selected === link.hash}"
					@click="selected = link.hash"
					:key="link.hash">
					{{ link.name }}
				</a>
			</div>
		</div>

		<div id="navMobile">
			<a 	href="#0" 
				id="trigger"
				@click="toggle">
				Menu
				<span :class="{openMenu: menuTrigger === true}"></span>
			</a>

			<nav id="navList">
				<ul :class="{'is-visible': menuTrigger === true}">
					<li v-for="link in mobile_links"
						v-scroll-to="{ el: link.hash, offset: 0 }"
						@click="close(link.hash)"
						:key="link.hash">
						<a>{{ link.name }}</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
export default{
	name:"Navbar",
	created(){
		this.$root.$on('scrolled', (id) => {this.selected = '#'+id;});
	},
	data(){
		return{
			selected:'#home',
			menuTrigger: false,
			normal_links:[
				{
					name: 'Home',
					hash: '#home'
				},
				{
					name: 'About',
					hash: '#about'
				},
				{
					name: 'Headshot & Resume',
					hash: '#headshot-resume'
				},
				{
					name: 'Media',
					hash: '#media'
				},
				{
					name: 'News',
					hash: '#news'
				},
				{
					name: 'Contact',
					hash: '#contact'
				},
			],
			mobile_links: [
				{
					name: 'Home',
					hash: '#home'
				},
				{
					name: 'About',
					hash: '#about'
				},
				{
					name: 'Headshot & Resume',
					hash: '#headshot-resume'
				},
				{
					name: 'Media',
					hash: '#media'
				},
				{
					name: 'News',
					hash: '#news'
				},
				{
					name: 'Contact',
					hash: '#contact'
				},
			],
		};
	},
	methods:{
		toggle: function(){ this.menuTrigger = !this.menuTrigger; },
		close: function(hash){
			this.selected = hash;
			this.menuTrigger = false;
		}
	}
}	
</script>

<style scoped lang="scss">
	@import "~@/assets/scss/_variables.scss";

	@import "~@/assets/scss/_mixins.scss";

	@import "~@/assets/scss/_layout.scss";


	@media screen and (min-width: $largeLaptopWidth){

	}

// navWrapper is parent element
// nav is actually floating nav
// Otherwise navWrapper remains fixed with rest of page

	#nav{
		height: 10vh;
		width: 100vw;
		position: fixed;
		background: $nearWhite;
		z-index: 100;
		display: grid;
		grid-template-columns: 50vw 50vw;	
		overflow: hidden;
		box-sizing: content-box;

		#navName {
			width: 90%;
			font-size: 2.5em;
			font-family: 'Montserrat', sans-serif;
			font-weight: bold;
			margin: auto;

			.navNameContent{
				width: 100%;
				display: grid;
				grid-template-columns: 20% 80%;

				h1{
					margin: auto auto auto 10px;
				}

				img{
					margin: auto;
					width: 95px;
				}
			}
		}

		#navBar{
			display: grid;
			float: right;
			max-width: 100%;
			max-height: 70%;
			overflow: hidden;
			height: fit-content;
			transform: translateY(calc(50% + 16px));
			text-align: center;
			grid-auto-flow: column;
			margin-right: 5%;

			a {
				font-family: 'Raleway', sans-serif;
				cursor: default;
				color: #2c3e50;
				text-decoration:none;
				margin: auto;
				box-sizing: content-box;
				height: fit-content;				

				&:hover{
					background: $lightPurple;
					color: white;
				}

				&.active {
					color: $darkPurple;
					border: 3px solid $lightPurple;
					padding: 0.1em;
				}
			}			
		}
	}

	@media screen and (max-width: $regularLaptopWidth){
		#nav{
			#navName{
				font-size: 2em;

				.navNameContent{
					img{
						width: 85px;
					}
				}
			}

			#navBar{
			}
		}
	}

	@media screen and (max-width: $tabletWidth){
		#nav{
			padding: 0;
			grid-template-columns: none;
			

			#navName{
				display: none;
			}

			#navBar{
				height: 100%;
				transform: translateY(0%);
				max-height: 100%;
			}
		}
	}

	@media screen and (min-width: $tabletWidth){
		#navMobile{
			display: none;
		}		
	}

	@media screen and (max-width: $largeMobile){
		#navWrapper{
			#nav{
				display: none;
			}

			#navMobile{
				#trigger {
					position: fixed;
					bottom: 5%;
					left: calc(50% - 44px);
					width: 44px;
					height: 44px;
					background: white;
					border-radius: 5em;
					/* image replacement */
					overflow: hidden;
					text-indent: 100%;
					white-space: nowrap;
					z-index: 10;
					transform: translateX(22px);
					border: 1px solid $lightPurple;

					span {
						/* the span element is used to create the menu icon */
						position: absolute;
						display: block;
						width: 20px;
						height: 2px;
						background: black;
						top: 50%;
						margin-top: -1px;
						left: 50%;
						margin-left: -10px;
						-webkit-transition: background 0.3s;
						-moz-transition: background 0.3s;
						transition: background 0.3s;

						&::before, &::after{
							content: '';
							position: absolute;
							left: 0;
							background: inherit;
							width: 100%;
							height: 100%;
							/* Force Hardware Acceleration in WebKit */
							-webkit-transform: translateZ(0);
							-moz-transform: translateZ(0);
							-ms-transform: translateZ(0);
							-o-transform: translateZ(0);
							transform: translateZ(0);
							-webkit-backface-visibility: hidden;
							backface-visibility: hidden;
							-webkit-transition: -webkit-transform 0.3s, background 0s;
							-moz-transition: -moz-transform 0.3s, background 0s;
							transition: transform 0.3s, background 0s;
						}

						&::before{
							top: -6px;
							-webkit-transform: rotate(0);
							-moz-transform: rotate(0);
							-ms-transform: rotate(0);
							-o-transform: rotate(0);
							transform: rotate(0);
						}

						&::after{
							bottom: -6px;
							-webkit-transform: rotate(0);
							-moz-transform: rotate(0);
							-ms-transform: rotate(0);
							-o-transform: rotate(0);
							transform: rotate(0);
						}

						&.openMenu{
							box-shadow: none;

							span{
								background: rgba(232, 74, 100, 0);

								&::before, &::after{
									bottom: -6px;
									-webkit-transform: rotate(0);
									-moz-transform: rotate(0);
									-ms-transform: rotate(0);
									-o-transform: rotate(0);
									transform: rotate(0);
								}

								&::before{
									top: 0;
									-webkit-transform: rotate(135deg);
									-moz-transform: rotate(135deg);
									-ms-transform: rotate(135deg);
									-o-transform: rotate(135deg);
									transform: rotate(135deg);
								}

								&::after{
									bottom: 0;
									-webkit-transform: rotate(225deg);
									-moz-transform: rotate(225deg);
									-ms-transform: rotate(225deg);
									-o-transform: rotate(225deg);
									transform: rotate(225deg);
								}
							}
						}
					}
				}

				#navList{
					ul {
						text-align: center;
						position: fixed;
						max-width: 100%;
						bottom: 5em;
						left: 10%;
						visibility: hidden;
						/* remove overflow:hidden if you want to create a drop-down menu - but then remember to fix/eliminate the list items animation */
						overflow: hidden;
						z-index: 10;
						/* Force Hardware Acceleration in WebKit */
						-webkit-backface-visibility: hidden;
						backface-visibility: hidden;
						-webkit-transform: scale(0);
						-moz-transform: scale(0);
						-ms-transform: scale(0);
						-o-transform: scale(0);
						transform: scale(0);
						-webkit-transform-origin: 100% 100%;
						-moz-transform-origin: 100% 100%;
						-ms-transform-origin: 100% 100%;
						-o-transform-origin: 100% 100%;
						transform-origin: 100% 100%;
						-webkit-transition: -webkit-transform 0.3s, visibility 0s 0.3s;
						-moz-transition: -moz-transform 0.3s, visibility 0s 0.3s;
						transition: transform 0.3s, visibility 0s 0.3s;

						li{
							/* Force Hardware Acceleration in WebKit */
							-webkit-backface-visibility: hidden;
							backface-visibility: hidden;

							a {
								text-align: center;
								color: $nearWhite;
								display: block;
								padding: 3vh;
								border-bottom: 2px solid $nearWhite;
								font-family: 'Raleway', sans-serif;

								&:hover{
									color: #00bd9b;
								}

							}
							&:last-child {
								a{
									border-bottom: none;
								}
							}
						}

						&.is-visible{
							background: $beigeMint;
							width: 80%;
							border: 1px solid $beigeMint;
							visibility: visible;
							border-radius: 15px;
							-webkit-transform: scale(1);
							-moz-transform: scale(1);
							-ms-transform: scale(1);
							-o-transform: scale(1);
							transform: scale(1);
							-webkit-transition: -webkit-transform 0.3s, visibility 0s 0s;
							-moz-transition: -moz-transform 0.3s, visibility 0s 0s;
							transition: transform 0.3s, visibility 0s 0s;

							li{
								&:nth-child(1){
									/* list items animation */
									-webkit-animation: slide-in 0.2s;
									-moz-animation: slide-in 0.2s;
									animation: slide-in 0.2s;									
								}
								&:nth-child(2) {
									-webkit-animation: slide-in 0.3s;
									-moz-animation: slide-in 0.3s;
									animation: slide-in 0.3s;
								}
								&:nth-child(3) {
									-webkit-animation: slide-in 0.4s;
									-moz-animation: slide-in 0.4s;
									animation: slide-in 0.4s;
								}
								&:nth-child(4) {
									-webkit-animation: slide-in 0.5s;
									-moz-animation: slide-in 0.5s;
									animation: slide-in 0.5s;
								}
								&:nth-child(5) {
									-webkit-animation: slide-in 0.6s;
									-moz-animation: slide-in 0.6s;
									animation: slide-in 0.6s;
								}
							}
						}
					}
				} 
			}
		}
	}

	@-webkit-keyframes slide-in {
		0% { -webkit-transform: translateX(100px); }
		100% { -webkit-transform: translateY(0); }
	}
	@-moz-keyframes slide-in {
		0% { -moz-transform: translateX(100px); }
		100% { -moz-transform: translateY(0); }
	}
	@keyframes slide-in {
		0% {
			-webkit-transform: translateX(100px);
			-moz-transform: translateX(100px);
			-ms-transform: translateX(100px);
			-o-transform: translateX(100px);
			transform: translateX(100px);
		}
		100% {
			-webkit-transform: translateY(0);
			-moz-transform: translateY(0);
			-ms-transform: translateY(0);
			-o-transform: translateY(0);
			transform: translateY(0);
		}
	}

	@-webkit-keyframes bounce-in {
		0% { -webkit-transform: scale(0); }
		60% { -webkit-transform: scale(1.2); }
		100% { -webkit-transform: scale(1); }
	}
	@-moz-keyframes bounce-in {
		0% { -moz-transform: scale(0); }
		60% { -moz-transform: scale(1.2); }
		100% { -moz-transform: scale(1); }
	}
	@keyframes bounce-in {
		0% {
			-webkit-transform: scale(0);
			-moz-transform: scale(0);
			-ms-transform: scale(0);
			-o-transform: scale(0);
			transform: scale(0);
		}

		60% {
			-webkit-transform: scale(1.2);
			-moz-transform: scale(1.2);
			-ms-transform: scale(1.2);
			-o-transform: scale(1.2);
			transform: scale(1.2);
		}

		100% {
			-webkit-transform: scale(1);
			-moz-transform: scale(1);
			-ms-transform: scale(1);
			-o-transform: scale(1);
			transform: scale(1);
		}
	}	
</style>